// export default '/api/'
export default 'https://mbpc.lt/api/'
// export default "http://localhost/";
